import React from "react";
import TurkeyIndex from "../pages/turkey/Index";
import "../styles/turkey.css";

const Turkey = () => {
  return (
    <div className="turkey-container">
      <TurkeyIndex />
    </div>
  );
};

export default Turkey;
